import styled from 'styled-components'

export const HeaderWrapper = styled.div`
  width: 100%;
`

export const HeaderRow = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 11px 20px;

  /* position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100; */
  background: rgba(254, 254, 254, 0.56);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.03);

  @media (min-width: ${({ theme }) => theme.breakpoints?.tablet}px) {
    padding: 16px 24px;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints?.desktop}px) {
    padding: 24px 80px;
    height: 64px;
  }
`
